import SubmenuObserver from '../submenu-observer';
import { restoreFocusForSubmenu, disableFocusForSubmenu } from '../submenu-tools';


const $ = jQuery;

export default function () {
	// Loading on windows.onload since custom javascript could
	// add its code, after DomReady event but before window.load event
	$(window).on('load', () => {
		// Wait for 2 seconds, since custom JS can take up to 1 second
		setTimeout(() => {
			$('.menu-item-has-children')
				.each(function () {
					const parentofSubmenu = $(this).children('a.da11y-submenu');
					if ((!parentofSubmenu.attr('href') || parentofSubmenu.attr('href') === '#') && parentofSubmenu.siblings('.sub-menu').length > 0) {
						parentofSubmenu.attr('role', 'button');
					}
					parentofSubmenu.attr('aria-expanded', false);

					const observer = new SubmenuObserver(this);
					observer.onShow(() => {
						parentofSubmenu.attr('aria-expanded', true);
						restoreFocusForSubmenu(this);
					});
					observer.onHide(() => {
						parentofSubmenu.attr('aria-expanded', false);
						disableFocusForSubmenu(this);
					});
					observer.connect();
				});
		}, 2000);
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/provide-aria-expanded-for-parentmenus.js